import {
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  makeStyles,
} from "@material-ui/core";
import React from "react";
import useFetch from "../../../../hooks/useFetch";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    borderRadius: "10px",
  },
  formControl: {
    minWidth: 145,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const Reject = () => {
  const classes = useStyles();
  const [view, setView] = React.useState("");
  const { data } = useFetch("https://abc-backend.onrender.com/api/quotes");
  const handleChange = (event) => {
    setView(event.target.value);
  };
  return (
    <div>
      <div className="approvalHeading">
        <Container>
          <Grid container spacing={1}>
            <Grid item xs={12} lg={1} md={12}>
              <h5 className="approvalTitle">RFQ No</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={1} md={12}>
              <h5 className="approvalTitle">Product Type</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={2} md={12}>
              {" "}
              <h5 className="approvalTitle lg3">Customer Name</h5>
              <input type="text" className="approvalInput lg3" />
            </Grid>
            <Grid item xs={12} lg={1} md={12}>
              {" "}
              <h5 className="approvalTitle">Weight</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={1} md={12}>
              <h5 className="approvalTitle">Size</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={2} md={12}>
              <h5 className="approvalTitle lg3">Ready to load</h5>
              <input
                type="date"
                data-date-inline-picker="true"
                className="approvalInput lg3"
              />
            </Grid>
            <Grid item xs={12} lg={1} md={12}>
              <h5 className="approvalTitle">From</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={1} md={12}>
              <h5 className="approvalTitle">To</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={1} md={12}>
              <h5 className="approvalTitle">Type</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={2} md={12}>
              <h5 className="approvalTitle">Actions</h5>
            </Grid>
          </Grid>
        </Container>
      </div>
      {data?.map((item) => (
        <>
          {item.reject && (
            <div className="approvalTabel">
              <Grid container spacing={1}>
                <Grid item xs={12} lg={1} md={12}>
                  <h5 className="approvalTabelTitle">100001</h5>
                </Grid>
                <Grid item xs={12} lg={1} md={12}>
                  <h5 className="approvalTabelTitle">
                    {item?.data?.quoteIntValue?.productType}
                  </h5>
                </Grid>
                <Grid item xs={12} lg={2} md={12}>
                  <h5 className="approvalTabelTitle lg3">
                    {
                      item?.data?.loadingUnDetailsValue[0]
                        ?.contactPersonNameFrom
                    }
                  </h5>
                </Grid>
                <Grid item xs={12} lg={1} md={12}>
                  <h5 className="approvalTabelTitle">
                    {item?.data?.productDetailsValue[0]?.weight}
                  </h5>
                </Grid>
                <Grid item xs={12} lg={1} md={12}>
                  <h5 className="approvalTabelTitle">
                    {" "}
                    {item?.data?.productDetailsValue[0]?.sizeInput}
                  </h5>
                </Grid>
                <Grid item xs={12} lg={2} md={12}>
                  <h5 className="approvalTabelTitle lg3">
                    {" "}
                    {item?.data?.quoteIntValue?.loadDate}
                  </h5>
                </Grid>
                <Grid item xs={12} lg={1} md={12}>
                  <h5 className="approvalTabelTitle">
                    {item?.data?.loadingUnDetailsValue[0]?.locationFrom}
                  </h5>
                </Grid>
                <Grid item xs={12} lg={1} md={12}>
                  <h5 className="approvalTabelTitle">
                    {item?.data?.loadingUnDetailsValue[0]?.locationTo}
                  </h5>
                </Grid>
                <Grid item xs={12} lg={1} md={12}>
                  <h5 className="approvalTabelTitle">
                    {" "}
                    {item?.data?.quoteIntValue?.transportationType}
                  </h5>
                </Grid>
                <Grid item xs={12} lg={2} md={2}>
                  <FormControl
                    variant="outlined"
                    className={(classes.formControl, "lg3")}
                  >
                    <InputLabel
                      id="demo-simple-select-autowidth-label"
                      style={{ margin: "0 auto" }}
                    >
                      Submit Quote
                    </InputLabel>
                    <Select
                      value={view}
                      onChange={handleChange}
                      displayEmpty
                      defaultValue={"Approve"}
                      inputProps={{ "aria-label": "Without label" }}
                    >
                      <MenuItem value={"Submit Quote"}>View</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </div>
          )}
        </>
      ))}
    </div>
  );
};

export default Reject;
